// Centralized ReasonVisionX branding assets.
// A product of Reason Analytics Softtech Pvt Limited (REASON).
// Swap these files to update branding everywhere — do not hard-code paths elsewhere.

import reasonVisionXLogo from './reasonvisionx-logo.png';   // full lockup (mark + wordmark)
import reasonVisionXMark from './reasonvisionx-mark.png';   // square product mark / app icon
import loginHero from './login-hero.jpg';                    // login brand-panel artwork
import reasonCorporateLogo from './reason-corporate-logo.png'; // official REASON parent-company logo

export const BRAND = {
  productName: 'ReasonVisionX',
  tagline: 'Visual intelligence for real-world construction',
  parentCompany: 'REASON',
  parentLegalName: 'Reason Analytics Softtech Pvt Limited',
  endorsement: 'A product by REASON',
};

export const assets = {
  logo: reasonVisionXLogo,
  mark: reasonVisionXMark,
  loginHero,
  // Official REASON corporate (parent-company) logo — transparent PNG.
  reasonCorporateLogo,
  // Placeholder slots for official government-recognition graphics. Drop the
  // official files in this folder and wire them here without touching layouts.
  dpiitBadge: null,          // official Startup India / DPIIT badge (when authorized)
  madeInIndiaBadge: null,    // official Made in India emblem (when authorized)
};

export default assets;
